import Register from './Register'
import RegisterExpert from './RegisterExpert'
import ActivateAccount from './Activate'
import Subscribe from './Subscribe'

export default [{
  path: '/user/register',
  name: 'Register',
  component: Register,
  meta: {showNavigation: false, title: 'Get started with ideXlab Open Innovation Platform'}
}, {
  path: '/expert/register',
  name: 'RegisterExpert',
  component: RegisterExpert,
  meta: {showNavigation: false, title: 'Sign up'}
}, {
  path: '/account/activate',
  name: 'ActivateAccount',
  component: ActivateAccount,
  meta: {showNavigation: false, title: 'Activate account'}
}, {
  path: '/subscribe/',
  name: 'Subscribe',
  component: Subscribe,
  meta: {showNavigation: false, title: 'Subscribe'}
}]



// WEBPACK FOOTER //
// ./src/pages/register/router.js